import * as React from 'react';
// import VendorMasterGrid from './screens/VendorMaster/VendorMasterGrid';
import YarnProjectionReports from './screens/YarnProjection/YarnProjectionReports';
const Dashboard = React.lazy(() => import('./screens/Dashboard'));
const StylesInProgress = React.lazy(() => import('./screens/StylesInProgress'));
const PendingVendor = React.lazy(() => import('./screens/VendorMaster/PendingVendor'));
const Settings = React.lazy(() => import('./screens/Settings/Settings'));
const AuditTrial = React.lazy(() => import('./screens/AuditTrial/AuditTrial'));
const SalesOrderAuthorize = React.lazy(() => import('./screens/SalesOrderAuthorize/index'))
const RNPendingReport = React.lazy(() => import('./screens/DKRequirements/Reports/RNPendingReport'));
const StitchingReport = React.lazy(() => import('./screens/DKRequirements/Reports/StitchingReports/index'));
const OcrReports = React.lazy(() => import('./screens/OCRReports/index'));
const productionInfo = React.lazy(() => import('./screens/ProductionInfo/index'));
const OcrClosedReports = React.lazy(() => import('./screens/OCRReports/OcrClosedReports'));
const MerchAuthorize = React.lazy(() => import('./screens/MerchAuthorize/index'))
const Pickup = React.lazy(() => import('./screens/Programs/Pickup'));
const PickupInfo = React.lazy(() => import('./screens/Programs/Pickup/PickupInfo'));
const PropertyMaster = React.lazy(() => import('./screens/PropertyMaster'));
const Property = React.lazy(() => import('./screens/PropertyMaster/Property'));
const StateMaster = React.lazy(() => import('./screens/StateMaster'));
const UserHeader = React.lazy(() => import('./screens/UserHeader'));
const CompanyMaster = React.lazy(() => import('./screens/CompanyMaster'));
const UnitMaster = React.lazy(() => import('./screens/CompanyMaster/UnitMaster'));
const MenuMaster = React.lazy(() => import('./screens/MenuMaster'));
const EmployeeTable = React.lazy(() => import('./screens/Employee'));
const AreaMaster = React.lazy(() => import('./screens/AreaMaster'));
const Roles = React.lazy(() => import('./screens/Roles'));
const ColorMaster = React.lazy(() => import('./screens/ColorMaster'));
const TeamMaster = React.lazy(() => import('./screens/TeamMaster'));
const PartyMaster = React.lazy(() => import('./screens/PartyMaster'));
const VendorMaster = React.lazy(() => import('./screens/VendorMaster'));
// ----vendor creation
const VendorCreation = React.lazy(() => import('./screens/VendorMaster/LandingPage'));
const VendorManagement = React.lazy(() => import('./screens/VendorManagement/index'));

const SizeInfo = React.lazy(() => import('./screens/SizeInfo'));
const YearMaster = React.lazy(() => import('./screens/YearMaster'));
const SeasonMaster = React.lazy(() => import('./screens/SeasonMaster'));
const SizeMeasurement = React.lazy(() => import('./screens/SizeMeasurementMaster'));
const UserAccessInfo = React.lazy(() => import('./screens/UserAccessInfo'));
const BankMaster = React.lazy(() => import('./screens/BankMaster'));
const AccountMaster = React.lazy(() => import('./screens/AccountMaster'));
const AccountTransaction = React.lazy(() => import('./screens/AccountTransaction'));
const HSNMaster = React.lazy(() => import('./screens/HSNMaster'));
const PriceMapping = React.lazy(() => import('./screens/PriceMapping'));
const PriceList = React.lazy(() => import('./screens/PriceList'));
const AccesoriesMasterWrapper = React.lazy(() => import('./screens/AccesoriesMaster'));
const BarcodeMasterWrapper = React.lazy(() => import('./screens/Barcode'));
const StyleMaster = React.lazy(() => import('./screens/StyleMaster'));
const BrandMaster = React.lazy(() => import('./screens/brandMaster'));
const AccessoriesUsageWrapper = React.lazy(() => import('./screens/AccessoriesUsage'));
const StockWrapper = React.lazy(() => import('./screens/Stock'));
const ProductWrapper = React.lazy(() => import('./screens/Product'));
const PartyDetailsWrapper = React.lazy(() => import('./screens/PartyMaster/PartyDetails'));
const DyeingDetails = React.lazy(() => import('./screens/DyeingDetails/DyeingDetailsHeader'))
const FeedbackWrapper = React.lazy(() => import('./screens/FeedbackMaster'));
const AsanaError = React.lazy(() => import('./screens/AsanaErrorPoints'));
const DefaultStyleMaster = React.lazy(() => import('./screens/DefaultStyleMaster'));
const ProgramMapping = React.lazy(() => import('./screens/ProgramMapping'));
const ProgramConstraint = React.lazy(() => import('./screens/ProgramConstraint'));
const ProcessWrapper = React.lazy(() => import('./screens/Process'));
const ProcessAssign = React.lazy(() => import('./screens/ProcessAssign'));
const SalesOrder = React.lazy(() => import('./screens/SalesOrder'));
const Process = React.lazy(() => import('./screens/Programs/Processess'));
const ProcessInward = React.lazy(() => import('./screens/Programs/ProcessessInward'));
const PackingEntry = React.lazy(() => import('./screens/PackingEntry'));
const ProductDispatch = React.lazy(() => import('./screens/DKRequirements/Reports/ProductDispatch'));
const ProductStock = React.lazy(() => import('./screens/DKRequirements/Reports/ProductStock'));
const Program = React.lazy(() => import('./screens/Programs/ProgramDC'));
const ProgramInward = React.lazy(() => import('./screens/Programs/ProgramDCInward'));
const MoveToCutting = React.lazy(() => import('./screens/Programs/MoveToCutting/MoveToCutting'))
const WareHouseStyle = React.lazy(() => import('./screens/WareHouseStyle'));
const WareHouseInwardApproval = React.lazy(() => import('./screens/WareHouseInwardApproval/index'));

const GateEntry = React.lazy(() => import('./GateEntry/ScanPage'));
const CapturePage = React.lazy(() => import('./GateEntry/CapturePage'));


const WarehouseInvoiceWrapper = React.lazy(() => import('./App/components/WareHouseInvoice'));

const WarehouseStyleInvoiceEPROWrapper = React.lazy(() => import('./App/components/WarehouseStyleInvoice'));
const SamplePo = React.lazy(() => import('./screens/Programs/SamplePo'));
const SamplePoInward = React.lazy(() => import('./screens/Programs/SamplePoInward'));
const SampleDC = React.lazy(() => import('./screens/Programs/SampleDC'));
const SampleDCInward = React.lazy(() => import('./screens/Programs/SampleDCInward'));
const CuttingReportsDateWise = React.lazy(() => import('./screens/CuttingReportsDateWise'));

const StyleUpCharge = React.lazy(() => import('./screens/StyleUpCharge'));
const StyleUpChargeReports = React.lazy(() => import('./screens/StyleUpCharge/UpchargeReports'));
const CuttingPgmInward = React.lazy(() => import('./screens/SalesOrder/CuttingPgmInward'));

const SalesOrderReports = React.lazy(() => import('./screens/SalesOrderReports'));

const CuttingProgram = React.lazy(() => import('./screens/CuttingProgram'));
const CuttingReports = React.lazy(() => import('./screens/CuttingReports'));
const FabricReports = React.lazy(() => import('./screens/FabricReports'));

const CuttingReportsPrint = React.lazy(() => import('./screens/CuttingReports/CuttingReportsPrint'));

const CostCenterReports = React.lazy(() => import('./screens/Programs/CostCenter'));

const ColorwiseCost = React.lazy(() => import('./screens/ColorwiseCost'));

const StylePreparations = React.lazy(() => import('./screens/StylePreparations'));
const FabricPo = React.lazy(() => import('./screens/Programs/FabricPo'));
const DyeingInwardWrapper = React.lazy(() => import('./screens/Programs/DyeingInward'));
const CuttingDcWrapper = React.lazy(() => import('./screens/Programs/CuttingDc'));
const GarmentsDcWrapper = React.lazy(() => import('./screens/Programs/GarmentPO'));
const GarmentsDcInwardWrapper = React.lazy(() => import('./screens/Programs/GarmentPOInward'));
const CustomerPO = React.lazy(() => import('./screens/Programs/CustomerPO'));

const StyleUpChargePrint = React.lazy(() => import('./screens/StyleUpCharge/StyleUpChargeInvoice'));


//const CuttingDcWrapper = React.lazy(() => import('./screens/Programs/CuttingDc'));

const YarnPO = React.lazy(() => import('./screens/Programs/YarnPO'));
const CompactingDC = React.lazy(() => import('./screens/Programs/CompactingDC'));
const DyeingDC = React.lazy(() => import('./screens/Programs/DyeingDC'));
const CompactingDivision = React.lazy(() => import('./screens/Programs/CompactingDivision'));
const CompactingDivisionInward = React.lazy(() => import('./screens/Programs/CompactingDivisionInward'));
const CompactingDivisionAuthorize = React.lazy(() => import('./screens/Programs/CompactingDivisionAuthorize'));
const KnittingDC = React.lazy(() => import('./screens/Programs/KnittingDC'));
const YarnInward = React.lazy(() => import('./screens/Programs/YarnInward'));
const AccessoriesDC = React.lazy(() => import('./screens/Programs/AccessoriesDC'));
const AccessoriesProcessDC = React.lazy(() => import('./screens/Programs/AccessoriesProcessDC'));
const AccessoriesPO = React.lazy(() => import('./screens/Programs/AccessoriesPO'));
const PrintingDC = React.lazy(() => import('./screens/Programs/PrintingDC'));
const Section = React.lazy(() => import('./screens/Section'));
const CompactingInward = React.lazy(() => import('./screens/Programs/CompactingInward'));
const FabricInward = React.lazy(() => import('./screens/Programs/FabricInward'));
const KnittingInward = React.lazy(() => import('./screens/Programs/KnittingInward'));
const GeneralPo = React.lazy(() => import('./screens/Programs/GeneralPo'));
const PrintingDcInwardWrapper = React.lazy(() => import('./screens/Programs/PrintingDcInward'));
const StitchingDC = React.lazy(() => import('./screens/Programs/StitchingDC'));
const StitchingInward = React.lazy(() => import('./screens/Programs/StitchingInward'));
const IroningAndPackingInward = React.lazy(() => import('./screens/Programs/IroningAndPackingInward'));
const MiscellaneousDC = React.lazy(() => import('./screens/Programs/MiscellaneousDC'));

const CheckingDcWrapper = React.lazy(() => import('./screens/Programs/CheckingDc'));
const GeneralPoInwardWrapper = React.lazy(() => import('./screens/Programs/GeneralPoInward'));
const AccessoriesPoInwardWrapper = React.lazy(() => import('./screens/Programs/AccessoriesPoInward'));
const AccessoriesProcessDCInwardWrapper = React.lazy(() => import('./screens/Programs/AccessoriesProcessDCInward'));
const AccessoriesDCInward = React.lazy(() => import('./screens/Programs/AccessoriesDCInward'));
const Costing = React.lazy(() => import('./screens/Programs/Costing'));
const CashRequistion = React.lazy(() => import('./screens/Programs/CashRequistion'));
const DirectBillingHeader = React.lazy(() => import('./screens/Programs/DirectBilling'));
const AccountProperty = React.lazy(() => import('./screens/Programs/AccountProperty'));
// const GeneralDC = React.lazy(() => import('./screens/Programs/GeneralDc'));
// const GeneralDcInwardWrapper = React.lazy(() => import('./screens/Programs/GeneralDcInward'));

const ProductionReport = React.lazy(() => import('./screens/DKRequirements/Reports/ProductionReport'));
const GeneralDC = React.lazy(() => import('./screens/Programs/GeneralDcNew'));
const GeneralDcInwardWrapper = React.lazy(() => import('./screens/Programs/GeneralDcInwardNew'));
const AdminDC = React.lazy(() => import('./screens/Programs/AdminDC'));
const ProgramCatalogues = React.lazy(() => import('./screens/Programs/ProgramCatalogues'));

const AdminDCInward = React.lazy(() => import('./screens/Programs/AdminDCInward'));
const CheckingDcInwardWrapper = React.lazy(() => import('./screens/Programs/CheckingDcInward'));
const CuttingDcInwardWrapper = React.lazy(() => import('./screens/Programs/CuttingDcInward'));
const FabricDC = React.lazy(() => import('./screens/Programs/FabricDc'));
const DespatchDC = React.lazy(() => import('./screens/Programs/DespatchDC'));
const PimMaster = React.lazy(() => import('./screens/Pim'));
const VerifyPIMGrid = React.lazy(() => import('./screens/VerifyPIM'));
const BillPayments = React.lazy(() => import('./screens/BillPayment'));
const ProcessAssignStyleMaster = React.lazy(() => import('./screens/ProcessAssignStyleMaster'));
const YarnMaster = React.lazy(() => import('./screens/YarnMaster'));
const FabricMaster = React.lazy(() => import('./screens/FabricMaster'));
const FilterWrapper = React.lazy(() => import('./screens/Filter'));
const AllOverPrintingDC = React.lazy(() => import('./screens/Programs/AllOverPrintingDC'));
const AllOverPrintingDCInward = React.lazy(() => import('./screens/Programs/AllOverPrintingDCInward'));
const IroningPackingDC = React.lazy(() => import('./screens/Programs/IroningPackingDC'));
const YarnProjection = React.lazy(() => import('./screens/YarnProjection'));
const FabricProjection = React.lazy(() => import('./screens/FabricProjection'));
const ArticleMaster = React.lazy(() => import('./screens/ArticleMaster'));
const SalesOrderEditAcc = React.lazy(() => import('./screens/SOAEditApproval'))

const StockReportsCP = React.lazy(() => import('./screens/DKRequirements/StockReportCP'));


// DK Requirements
const DashboardDK = React.lazy(() => import('./screens/DKRequirements/Dashboard'));
const Reports = React.lazy(() => import('./screens/DKRequirements/Reports/Reports'));
const ProgramWiseReportDK = React.lazy(() => import('./screens/DKRequirements/Reports/ProgramWiseReport'));
const SalesOrderReqReportDK = React.lazy(() => import('./screens/DKRequirements/Reports/salesOrderReqReport'));
const SupplierWiseReportDK = React.lazy(() => import('./screens/DKRequirements/Reports/SupplierWiseReport'));
const ActiveParties = React.lazy(() => import('./screens/ActiveParties/index'));
const StyleWiseReport = React.lazy(() => import('./screens/DKRequirements/Reports/StyleWiseReport'));
const FabricStatusReport = React.lazy(() => import('./screens/DKRequirements/Reports/StyleWiseReport'));
const CompactingStatusReport = React.lazy(() => import('./screens/DKRequirements/Reports/CompactingStatusReport'));

const YarnPOOutStanding = React.lazy(() => import('./screens/Programs/OutStanding/YarnOutStanding'));
const YarnProjectionOutStanding = React.lazy(() => import('./screens/Programs/OutStanding/YarnProjectionOutStanding'));

const CompactingReport = React.lazy(() => import('./screens/DKRequirements/Reports/CompactingReport'));
// const ProjectionReport = React.lazy(() => import('./screens/DKRequirements/Reports/ProjectionReport'));
const StockReports = React.lazy(() => import('./screens/DKRequirements/Stocks/StockWiseReports'));
// const StockReportsLedger = React.lazy(() => import('./screens/DKRequirements/Stocks/StockWiseReportsLedger'));
const StockWiseReportsLedger = React.lazy(() => import('./screens/DKRequirements/Stocks'));
//const StockWiseReportsLedgerDetailGrid = React.lazy(() => import('./screens/DKRequirements/Stocks/StockWiseReportsLedgerDetailGrid'));
const YarnPODK = React.lazy(() => import('./screens/DKRequirements/Programs/YarnPO'));
const YarnInwardDK = React.lazy(() => import('./screens/DKRequirements/Programs/YarnInward'));
const FabricInwardDK = React.lazy(() => import('./screens/DKRequirements/Programs/FabricInward'));
const SKUMasterWrapper = React.lazy(() => import('./screens/DKRequirements/StyleMasterBasic/SkuMaster'));
const FabricPoDK = React.lazy(() => import('./screens/DKRequirements/Programs/FabricPo'));
const KnittingInwardDK = React.lazy(() => import('./screens/DKRequirements/Programs/KnittingInward'));
const DyeingInwardWrapperDK = React.lazy(() => import('./screens/DKRequirements/Programs/DyeingInward'));
const ProcessWrapperDK = React.lazy(() => import('./screens/DKRequirements/Process'));
const ProcessAssignStyleMasterDK = React.lazy(() => import('./screens/DKRequirements/ProcessAssignStyleMaster'));
const KnittingDCDK = React.lazy(() => import('./screens/DKRequirements/Programs/KnittingDC'));
const GeneralPoDK = React.lazy(() => import('./screens/DKRequirements/Programs/GeneralPo'));
const GeneralInwardDK = React.lazy(() => import('./screens/DKRequirements/Programs/GeneralPoInward'));
const DyeingDCDK = React.lazy(() => import('./screens/DKRequirements/Programs/DyeingDC'));
const GeneralDCDK = React.lazy(() => import('./screens/DKRequirements/Programs/GeneralDC'));
const GeneralDCInwardDK = React.lazy(() => import('./screens/DKRequirements/Programs/GeneralDcInward'));
const PrintingDcInwardWrapperDK = React.lazy(() => import('./screens/DKRequirements/Programs/PrintingDcInward'));
const AccessoriesPoDK = React.lazy(() => import('./screens/DKRequirements/Programs/AccessoriesPO'));
const AccessoriesInwardDK = React.lazy(() => import('./screens/DKRequirements/Programs/AccessoriesPoInward'));
const PrintingDCDK = React.lazy(() => import('./screens/DKRequirements/Programs/PrintingDC'));
const PrintingDC2DK = React.lazy(() => import('./screens/DKRequirements/Programs/PrintingDC2'));
const Printing2InwardWrapperDK = React.lazy(() => import('./screens/DKRequirements/Programs/Printing2Inward'));
const CompactingInwardDK = React.lazy(() => import('./screens/DKRequirements/Programs/CompactingInward'));
const CompactingDCDK = React.lazy(() => import('./screens/DKRequirements/Programs/CompactingDC'));
const WashingDCDK = React.lazy(() => import('./screens/DKRequirements/Programs/WashingDC'));
const WashingInwardWrapperDK = React.lazy(() => import('./screens/DKRequirements/Programs/WashingInward'));
const CuttingDCDK = React.lazy(() => import('./screens/DKRequirements/Programs/CuttingDC'));
const AccessoriesDCDK = React.lazy(() => import('./screens/DKRequirements/Programs/AccessoriesDC'));
const IroningPackingInwardWrapperDK = React.lazy(() => import('./screens/DKRequirements/Programs/IroningPackingInward'));
const CuttingInwardWrapperDK = React.lazy(() => import('./screens/DKRequirements/Programs/CuttingInward'));
const StitchingDCDK = React.lazy(() => import('./screens/DKRequirements/Programs/StitchingDc'));
const DespatchDcMasterGrid = React.lazy(() => import('./screens/DKRequirements/Programs/DespatchDC/DespatchDcHeader'));
const StitchingInwardWrapperDK = React.lazy(() => import('./screens/DKRequirements/Programs/StitchingInward'));
const IroningPackingDCDK = React.lazy(() => import('./screens/DKRequirements/Programs/IroningPackingDC'));
// const StitchingDCDK = React.lazy(() => import('./screens/DKRequirements/Programs/IroningPackingDC'));
// const DespatchDcMasterGrid = React.lazy(() => import('./screens/DKRequirements/Programs/DespatchDC'));
const AddEntriesDK = React.lazy(() => import('./screens/DKRequirements/BillEntries/AddEntries'));
const EditEntries = React.lazy(() => import('./screens/DKRequirements/BillEntries/EditEntries'));
const VerifyEntriesDK = React.lazy(() => import('./screens/DKRequirements/BillEntries/VerifyEntries'));
const VerifiedBills = React.lazy(() => import('./screens/DKRequirements/BillEntries/VerifiedBills'));
const ProgramDiscount = React.lazy(() => import('./screens/DKRequirements/ProgramDiscount'));
// const EditVerification = React.lazy(() => import('./screens/DKRequirements/BillEntries/EditVerification'));
const BillEntryReport = React.lazy(() => import('./screens/DKRequirements/Reports/BillEntryReport'));
const BillEntryReportsAll = React.lazy(() => import('./screens/DKRequirements/Reports/BillEntryReportsAll'));
const CloseBillEntryReport = React.lazy(() => import('./screens/DKRequirements/Reports/CloseBillEntryReport'));
const ContractorBill = React.lazy(() => import('./screens/DKRequirements/BillEntries/ContractorBill'));
// const Invoice = React.lazy(() => import('./screens/Programs/YarnPO/Invoice'));
const StylePreparationInvoice = React.lazy(() => import('./screens/StylePreparations/StylePreparationInvoice'));
const DemandInvoice = React.lazy(() => import('./screens/SalesOrder/DemandInvoice'));
const YarnProjectionInvoice = React.lazy(() => import('./screens/YarnProjection/YarnProjectionInvoice'));
const FabricProjectionInvoice = React.lazy(() => import('./screens/FabricProjection/FabricProjectionInvoice'));
const CommonInvoiceWrapper = React.lazy(() => import('./App/components/CommonInvoice'));
const CommonInvoiceEPROWrapper = React.lazy(() => import('./App/components/CommonInvoiceEprov2'));
const StitchingInvoiceWrapper = React.lazy(() => import('./App/components/StitchingInvoiceV2'));
const ContractorBillEPPRO = React.lazy(() => import('./App/components/ContractorInvoiceEprov2'));
const CashRequisitionEPRO = React.lazy(() => import('./App/components/CashRequisitionInvoiceEproV2'));

const DebitMemo = React.lazy(() => import('./screens/DKRequirements/BillEntries/DebitMemo'));

const DebitMemoReport = React.lazy(() => import('./screens/DKRequirements/Reports/DebitMemoReports'));

const CuttingReportsGSM = React.lazy(() => import('./screens/CuttingReportsGSM'))

const FabricRoughCosting = React.lazy(() => import('./screens/Programs/RoughCosting'))


const SOAPrint = React.lazy(() => import('./screens/SOAEditApproval/SOAInvoice'));


const ShippingPlan = React.lazy(() => import('./screens/ShippingPlan'));

const RequestForm = React.lazy(() => import('./screens/RequestFrom'));
const RequestFormInvoice = React.lazy(() => import('./screens/RequestFrom/RequestFormInvoice'));
const OCRInvoiceWrapper = React.lazy(() => import('./screens/SalesOrder/OCRInvoice'));
const BillRecieving = React.lazy(() => import('./screens/DKRequirements/BillEntries/BillRecieving'));
const BillRecievingReport = React.lazy(() => import('./screens/DKRequirements/BillEntries/BillReceivingReport'));
const BillReceivingVerify = React.lazy(() => import('./screens/DKRequirements/BillEntries/BillReceivingVerify'));

const routes = [
    { path: '/dashboard', exact: true, name: 'Dashboard Page', component: Dashboard },
    { path: '/property-master', exact: true, name: 'Property Master Page', component: PropertyMaster },
    { path: '/properties', exact: true, name: 'Property Page', component: Property },
    { path: '/settings', exact: true, name: 'Settings Page', component: Settings },
    { path: '/audit-log', exact: true, name: 'Audit Trial Page', component: AuditTrial },
    { path: '/state-master', exact: true, name: 'State Master Page', component: StateMaster },
    { path: '/filter', exact: true, name: 'Filter Page', component: FilterWrapper },
    { path: '/party-master', exact: true, name: 'Party Master Page', component: PartyMaster },
    { path: '/registered-vendor', exact: true, name: 'Registered Vendor Page', component: VendorMaster },

    { path: '/gate-entry-scan', exact: true, name: 'Gate Entry Page', component: GateEntry },

    { path: '/gate-entry-capture', exact: true, name: 'Capture Page', component: CapturePage },

    { path: '/vendor-creation', exact: true, name: 'Create Vendor Page', component: VendorCreation },

    { path: '/vendorManagement', exact: true, name: 'Vendor Management Page', component: VendorManagement },

    { path: '/pending-vendor', exact: true, name: 'Pending Vendor Page', component: PendingVendor },
    { path: '/user-header', exact: true, name: 'User Header Page', component: UserHeader },
    { path: '/area-master', exact: true, name: 'Area Master Page', component: AreaMaster },
    { path: '/article-master', exact: true, name: 'Article Master Page', component: ArticleMaster },
    { path: '/company-master', exact: true, name: 'Company Master Page', component: CompanyMaster },
    { path: '/unit-master', exact: true, name: 'Unit Master Page', component: UnitMaster },
    { path: '/menu-master', exact: true, name: 'Menu Master Page', component: MenuMaster },
    { path: '/employee', exact: true, name: 'Employee Page', component: EmployeeTable },
    { path: '/size-info', exact: true, name: 'Size Info Page', component: SizeInfo },
    { path: '/roles', exact: true, name: 'Roles Page', component: Roles },
    { path: '/year-master', exact: true, name: 'Year Master Page', component: YearMaster },
    { path: '/season-master', exact: true, name: 'Season Master Page', component: SeasonMaster },
    { path: '/size-measurement-master', exact: true, name: 'Size Measurement Page', component: SizeMeasurement },
    { path: '/colour-master', exact: true, name: 'Colour Master Page', component: ColorMaster },
    { path: '/style-verification-fabric', exact: true, name: 'sales Order Fabric Authorize Page', component: SalesOrderAuthorize },
    { path: '/team-master', exact: true, name: 'Team Master Page', component: TeamMaster },
    { path: '/user-access-info', exact: true, name: 'User Access Info Page', component: UserAccessInfo },
    { path: '/bank-master', exact: true, name: 'Bank Master Page', component: BankMaster },
    { path: '/account-master', exact: true, name: 'Account Master Page', component: AccountMaster },
    { path: '/account-transaction', exact: true, name: 'Account Master Page', component: AccountTransaction },
    { path: '/brand-master', exact: true, name: 'Brand Master Page', component: BrandMaster },
    { path: '/style-creation', exact: true, name: 'Style Master Page', component: StyleMaster },
    { path: '/hsn-master', exact: true, name: 'Bank Master Page', component: HSNMaster },
    { path: '/price-mapping', exact: true, name: 'Price Mapping Page', component: PriceMapping },
    { path: '/price-list', exact: true, name: 'Price List Page', component: PriceList },
    { path: '/accessories-master', exact: true, name: 'Bank Master Page', component: AccesoriesMasterWrapper },
    { path: '/ocr-invoice', exact: true, name: 'OCR Master Page', component: OCRInvoiceWrapper },
    { path: '/barcode', exact: true, name: 'Barcode Master Page', component: BarcodeMasterWrapper },
    { path: '/accessories-usage', exact: true, name: 'Bank Master Page', component: AccessoriesUsageWrapper },
    { path: '/stock', exact: true, name: 'Bank Master Page', component: StockWrapper },
    { path: '/product', exact: true, name: 'Product', component: ProductWrapper },
    { path: '/party-details', exact: true, name: 'Party Details Page', component: PartyDetailsWrapper },
    { path: '/feedback-master', exact: true, name: 'Feedback Master Page', component: FeedbackWrapper },
    { path: '/AsanaError-Points', exact: true, name: 'AsanaErrors Page', component: AsanaError },
    { path: '/ocr-reports', exact: true, name: 'Product Stock Page', component: OcrReports },
    { path: '/production-info', exact: true, name: 'Product Stock Page', component: productionInfo },
    { path: '/ocr-closed-reports', exact: true, name: 'OCR Closed Page', component: OcrClosedReports },

    { path: '/stock-report-cp', exact: true, name: 'Stock Reports CP Page', component: StockReportsCP },

    { path: '/default-style-detail', exact: true, name: 'Default Style Master Page', component: DefaultStyleMaster },
    { path: '/program-mapping', exact: true, name: 'Program Mapping Page', component: ProgramMapping },
    { path: '/program-constarint', exact: true, name: 'Program Constarint Page', component: ProgramConstraint },
    { path: '/process', exact: true, name: 'Process Page', component: ProcessWrapper },
    // { path: '/assign-process', exact: true, name: 'Process Page', component: ProcessAssign },
    { path: '/sale-order', exact: true, name: 'Program Constarint Page', component: SalesOrder },
    { path: '/costing-report', exact: true, name: 'Program Constarint Page', component: SalesOrderReports },

    { path: '/process-dc', exact: true, name: 'Process Page', component: Process },
    { path: '/process-inward', exact: true, name: 'Process Inward Page', component: ProcessInward },
    { path: '/warehouse-dispatch', exact: true, name: 'Product Dispatch Page', component: ProductDispatch },
    { path: '/warehouse-stock', exact: true, name: 'Product Stock Page', component: ProductStock },
    { path: '/program-dc', exact: true, name: 'Program Page', component: Program },

    { path: '/sales-order-requirement', exact: true, name: 'sales Order Edit Page', component: SalesOrderEditAcc },

    { path: '/yarn-outStanding', exact: true, name: 'Yarn OutStanding Page', component: YarnPOOutStanding },

    { path: '/yarn-projection-outStanding', exact: true, name: 'Yarn Projection OutStanding', component: YarnProjectionOutStanding },


    { path: '/move-to-cutting', exact: true, name: 'Move To Cutting Page', component: MoveToCutting },

    { path: '/program-inward', exact: true, name: 'Program Inward Page', component: ProgramInward },

    { path: '/warehouse-inward', exact: true, name: 'Warehouse Inward Page', component: PackingEntry },

    { path: '/sample-po', exact: true, name: 'Sample Page', component: SamplePo },
    { path: '/sample-po-inward', exact: true, name: 'Sample Page', component: SamplePoInward },

    { path: '/warehouse-receiving', exact: true, name: 'Warehouse Receiving', component: WareHouseInwardApproval },




    { path: '/sample-dc', exact: true, name: 'Sample Page', component: SampleDC },
    { path: '/sample-dc-inward', exact: true, name: 'Sample Inward Page', component: SampleDCInward },

    { path: '/miscellaneous-dc', exact: true, name: 'Miscellaneous DC', component: MiscellaneousDC },

    { path: '/Debit-Memo', exact: true, name: 'Debit Memo', component: DebitMemo },

    { path: '/debit-memo-reports', exact: true, name: 'Debit Memo Report', component: DebitMemoReport },
    { path: '/cost-center-report', exact: true, name: 'Cost Center Report', component: CostCenterReports },

    { path: '/SOA-invoice', exact: true, name: 'Style UpCharge Print Page', component: SOAPrint },

    { path: '/pickup-entry', exact: true, name: 'Process Page', component: Pickup },

    { path: '/pickup-info', exact: true, name: 'Process Page', component: PickupInfo },


    { path: '/cutting-program', exact: true, name: 'Program Constarint Page', component: CuttingProgram },

    { path: '/cutting-reports', exact: true, name: 'Program Constarint Page', component: CuttingReports },

    { path: '/cutting-reports-date-wise', exact: true, name: 'cutting Reports Date Wise', component: CuttingReportsDateWise },

    { path: '/fabric-reports', exact: true, name: 'Program Constarint Page', component: FabricReports },

    { path: '/cutting-reports-view', exact: true, name: 'Program Constarint Page', component: CuttingReportsGSM },

    { path: '/fabric-rough-costing', exact: true, name: 'Program Constarint Page', component: FabricRoughCosting },

    { path: '/program-constarint', exact: true, name: 'Program Constraint Page', component: ProgramConstraint },
    // { path: '/process', exact: true, name: 'Program Constraint Page', component: ProcessWrapper },
    { path: '/style-preparation', exact: true, name: 'Program Constraint Page', component: StylePreparations },

    { path: '/fabric-po', exact: true, name: 'Fabric PO Page', component: FabricPo },
    { path: '/yarn-po', exact: true, name: 'Yarn PO Page', component: YarnPO },

    { path: '/dyeing-inward', exact: true, name: 'Dyeing Inward Page', component: DyeingInwardWrapper },
    { path: '/cutting-dc', exact: true, name: 'Cutting DC Page', component: CuttingDcWrapper },
    { path: '/cutting-invoice', exact: true, name: 'Cutting Print Page', component: CuttingReportsPrint },

    { path: '/styles-progress', exact: true, name: 'Styles InProgress Page', component: StylesInProgress },

    { path: '/garments-po', exact: true, name: 'Garments PO Page', component: GarmentsDcWrapper },
    { path: '/garments-inward', exact: true, name: 'garments Inward Page', component: GarmentsDcInwardWrapper },
    { path: '/customer-po', exact: true, name: 'Customer PO Page', component: CustomerPO },
    { path: '/stitching-dc', exact: true, name: 'Stitching DC Page', component: StitchingDC },
    { path: '/stitching-inward', exact: true, name: 'Stitching Inward Page', component: StitchingInward },
    { path: '/yarn-inward', exact: true, name: 'Yarn Inward Page', component: YarnInward },
    { path: '/knitting-dc', exact: true, name: 'Yarn Inward Page', component: KnittingDC },
    { path: '/dyeing-dc', exact: true, name: 'Yarn Inward Page', component: DyeingDC },
    { path: '/compacting-dc', exact: true, name: 'Yarn Inward Page', component: CompactingDC },
    { path: '/compacting-receiving-note', exact: true, name: 'Compacting Division Page', component: CompactingDivision },
    { path: '/compacting-delivery-note', exact: true, name: 'Compacting Division Inward Page', component: CompactingDivisionInward },
    { path: '/compacting-authorize-note', exact: true, name: 'Compacting Authorize', component: CompactingDivisionAuthorize },
    { path: '/accessories-po', exact: true, name: 'Yarn Inward Page', component: AccessoriesPO },
    { path: '/rn-pending-report', exact: true, name: 'RN Pending Report Page', component: RNPendingReport },

    { path: '/stitching-reports', exact: true, name: 'Stitching Report Page', component: StitchingReport },

    { path: '/accessories-dc', exact: true, name: 'Yarn Inward Page', component: AccessoriesDC },
    { path: '/accessories-process-dc', exact: true, name: 'Yarn Inward Page', component: AccessoriesProcessDC },
    { path: '/printing-dc', exact: true, name: 'Yarn Inward Page', component: PrintingDC },
    { path: '/section', exact: true, name: 'Section', component: Section },
    { path: '/compacting-inward', exact: true, name: 'Yarn Inward Page', component: CompactingInward },
    { path: '/knitting-inward', exact: true, name: 'Yarn Inward Page', component: KnittingInward },
    { path: '/ironingAndPacking-inward', exact: true, name: 'Ironing And Packing Inward Page', component: IroningAndPackingInward },
    { path: '/fabric-inward', exact: true, name: 'Yarn Inward Page', component: FabricInward },
    { path: '/dyeing-details', exact: true, name: 'Price List Page', component: DyeingDetails },
    { path: '/cutting-inward', exact: true, name: 'Yarn Inward Page', component: CuttingDcInwardWrapper },
    { path: '/general-po', exact: true, name: 'General PO Page', component: GeneralPo },
    { path: '/printing-inward', exact: true, name: 'Printing DC Inward Page', component: PrintingDcInwardWrapper },
    { path: '/checking-dc', exact: true, name: 'Checking DC Page', component: CheckingDcWrapper },
    { path: '/despatch-dc', exact: true, name: 'Despatch DC Page', component: DespatchDC },
    { path: '/general-po-inward', exact: true, name: 'Despatch DC Page', component: GeneralPoInwardWrapper },

    { path: '/styles-progress', exact: true, name: 'Styles InProgress Page', component: StylesInProgress },

    { path: '/accessories-po-inward', exact: true, name: 'Accessories Po Inward Page', component: AccessoriesPoInwardWrapper },
    { path: '/accessories-process-dc-inward', exact: true, name: 'Accessories Process DC Inward Page', component: AccessoriesProcessDCInwardWrapper },
    { path: '/accessories-dc-inward', exact: true, name: 'Accessories DC Inward Page', component: AccessoriesDCInward },
    { path: '/general-dc', exact: true, name: 'General DC Page', component: GeneralDC },
    { path: '/general-dc-inward', exact: true, name: 'General DC Inward Page', component: GeneralDcInwardWrapper },
    { path: '/admin-dc', exact: true, name: 'Admin DC Page', component: AdminDC },
    { path: '/program-catalogues', exact: true, name: 'Program Catalogues Page', component: ProgramCatalogues },
    { path: '/admin-inward', exact: true, name: 'Admin DC Inward Page', component: AdminDCInward },
    { path: '/checking-dc-inward', exact: true, name: 'Checking DC Inward Page', component: CheckingDcInwardWrapper },

    { path: '/ware-house-style', exact: true, name: 'Ware House Style Page', component: WareHouseStyle },

    { path: '/warehouse-invoice', exact: true, name: 'WarehouseInvoice Epro Page', component: WarehouseInvoiceWrapper },


    { path: '/fabric-dc', exact: true, name: 'Fabric DC Page', component: FabricDC },
    { path: '/pim', exact: true, name: 'PIM Page', component: PimMaster },
    { path: '/verify-pim', exact: true, name: 'Verify PIM Page', component: VerifyPIMGrid },
    { path: '/bill-payment', exact: true, name: 'Bill Payment Page', component: BillPayments },
    { path: '/bill-payment', exact: true, name: 'Bill Payment Page', component: BillPayments },
    { path: '/process-assign-style-master', exact: true, name: 'Process Assign Style Master Page', component: ProcessAssignStyleMaster },
    { path: '/yarn-master', exact: true, name: 'Yarn Master Page', component: YarnMaster },

    { path: '/color-wise-cost', exact: true, name: 'Colorwise Cost Page', component: ColorwiseCost },

    { path: '/fabric-master', exact: true, name: 'Fabric Master Page', component: FabricMaster },
    // { path: '/yarn-po/invoice', exact: true, name: 'Fabric Master Page', component: Invoice },
    { path: '/style-verification-merch', exact: true, name: 'sales Order Merch Authorize Page', component: MerchAuthorize },
    { path: '/style-preparation/StylePreparationInvoice', exact: true, name: 'Style Preparation Page', component: StylePreparationInvoice },
    { path: '/sales-order/DemandInvoice', exact: true, name: 'Sales order Print Page', component: DemandInvoice },
    { path: '/warehouse-style-invoice', exact: true, name: 'Warehouse Style Invoice Epro Page', component: WarehouseStyleInvoiceEPROWrapper },
    { path: '/yarn-projection', exact: true, name: 'Yarn Projection Page', component: YarnProjection },
    { path: '/yarn-projection-reports', exact: true, name: 'Yarn Projection Page', component: YarnProjectionReports },
    { path: '/yarn-projection/YarnProjectionInvoice', exact: true, name: 'Yarn Projection Invoice Page', component: YarnProjectionInvoice },
    { path: '/fabric-projection', exact: true, name: 'Fabric Projection Page', component: FabricProjection },
    { path: '/fabric-projection/FabricProjectionInvoice', exact: true, name: 'Fabric Projection Invoice Page', component: FabricProjectionInvoice },
    { path: '/production-report', exact: true, name: 'Production Report Page', component: ProductionReport },
    { path: '/invoice', exact: true, name: 'Fabric Master Page', component: CommonInvoiceWrapper },
    { path: '/despatchs-dc', exact: true, name: 'Despatch DC Page', component: DespatchDcMasterGrid },
    { path: '/epro-invoice', exact: true, name: 'Common Invoice Epro Page', component: CommonInvoiceEPROWrapper },
    { path: '/stitch-invoice', exact: true, name: 'Common Invoice Epro Page', component: StitchingInvoiceWrapper },
    { path: '/costing', exact: true, name: 'Costing', component: Costing },
    { path: '/cash-requisition', exact: true, name: 'Cash Requisition', component: CashRequistion },
    { path: '/direct-billing', exact: true, name: 'Direct Billing', component: DirectBillingHeader },
    { path: '/account-property', exact: true, name: 'Account Property', component: AccountProperty },
    { path: '/contractor-invoice', exact: true, name: 'Contractor Invoice Epro Page', component: ContractorBillEPPRO },
    { path: '/cash-invoice', exact: true, name: 'Cash Invoice Epro Page', component: CashRequisitionEPRO },

    { path: '/sales-order/CuttingPgmInward', exact: true, name: 'Sales order Cutting Program Inward Print Page', component: CuttingPgmInward },

    { path: '/style-upCharge', exact: true, name: 'Style Master Page', component: StyleUpCharge },

    { path: '/style-upCharge-reports', exact: true, name: 'Style Master Page', component: StyleUpChargeReports },

    { path: '/shipping-plan', exact: true, name: 'Program Constarint Page', component: ShippingPlan },

    { path: '/cutting-invoice', exact: true, name: 'Cutting Print Page', component: CuttingReportsPrint },
    { path: '/request-form', exact: true, name: 'Request Form Page', component: RequestForm },
    { path: '/request-form/RequestFormInvoice', exact: true, name: 'Request Form Invoice Page', component: RequestFormInvoice },

    { path: '/upCharge-invoice', exact: true, name: 'Style UpCharge Print Page', component: StyleUpChargePrint },

    //DK Requirements
    { path: '/bulk/dashboard', exact: true, name: 'Dashboard Page', component: DashboardDK },
    { path: '/reports', exact: true, name: 'Reports Page', component: Reports },
    { path: '/program-wise-report', exact: true, name: 'Program Wise Report Page', component: ProgramWiseReportDK },
    { path: '/sales-order-requirement-report', exact: true, name: 'Sales Order Requirement Report Page', component: SalesOrderReqReportDK },
    { path: '/supplier-wise-report', exact: true, name: 'Supplier Wise Report Page', component: SupplierWiseReportDK },
    { path: '/active-parties', exact: true, name: 'Active Parties Page', component: ActiveParties },
    { path: '/style-wise-report', exact: true, name: 'Style Wise Report Page', component: StyleWiseReport },
    { path: '/fabric-status-report', exact: true, name: 'Fabric Status Report Page', component: FabricStatusReport },

    { path: '/compacting-status-report', exact: true, name: 'Compacting Status Report Page', component: CompactingStatusReport },



    { path: '/compacting-report', exact: true, name: 'Compacting Report Page', component: CompactingReport },
    // { path: '/projection-report', exact: true, name: 'Projection Report Page', component: ProjectionReport },
    { path: '/billEntries', exact: true, name: 'Bill Entries', component: AddEntriesDK },
    { path: '/Edit-Entries', exact: true, name: 'Edit Bill Entries', component: EditEntries },
    { path: '/verify-billentry', exact: true, name: 'Verify Bill Entries', component: VerifyEntriesDK },
    { path: '/verifiedBills', exact: true, name: 'Verified Bills', component: VerifiedBills },
    { path: '/program-discount', exact: true, name: 'Program Discount', component: ProgramDiscount },
    // { path: '/edit-verification', exact: true, name: 'Edit Verification', component: EditVerification },
    { path: '/bill-entries-reports', exact: true, name: 'Bill Entries Report', component: BillEntryReport },
    { path: '/bill-entries-reports-all', exact: true, name: 'Bill Entries Reports All', component: BillEntryReportsAll },
    { path: '/Close-BillEntry-Report', exact: true, name: 'Close BillEntry Report', component: CloseBillEntryReport },
    { path: '/Contractor-Bill', exact: true, name: 'Contractor Bill', component: ContractorBill },
    { path: '/bulk/stock-report', exact: true, name: 'Stock Reports Page', component: StockReports },
    { path: '/bulk/stock-report-ledger', exact: true, name: 'Stock Reports Page', component: StockWiseReportsLedger },
    //{ path: '/bulk/stock-report-ledger-details', exact: true, name: 'Stock Reports Page', component: StockWiseReportsLedgerDetailGrid },
    { path: '/bulk/yarn-po', exact: true, name: 'Yarn PO Page', component: YarnPODK },
    { path: '/bulk/yarn-inward', exact: true, name: 'Yarn Inward Page', component: YarnInwardDK },
    { path: '/bulk/fabric-inward', exact: true, name: 'Fabric Inward Page', component: FabricInwardDK },
    { path: '/bulk/SKU-master', exact: true, name: 'SKU Master Page', component: SKUMasterWrapper },
    { path: '/bulk/fabric-po', exact: true, name: 'Fabric PO Page', component: FabricPoDK },
    { path: '/bulk/knitting-inward', exact: true, name: 'Knitting Inward Page', component: KnittingInwardDK },
    { path: '/bulk/dyeing-inward', exact: true, name: 'Dyeing Inward Page', component: DyeingInwardWrapperDK },
    { path: '/bulk/process', exact: true, name: 'Process Page', component: ProcessWrapperDK },
    { path: '/bulk/knitting-dc', exact: true, name: 'Knitting DC Page', component: KnittingDCDK },
    { path: '/bulk/general-po', exact: true, name: 'General PO Page', component: GeneralPoDK },
    { path: '/bulk/general-inward', exact: true, name: 'General Inward Page', component: GeneralInwardDK },
    { path: '/bulk/dyeing-dc', exact: true, name: 'Dyeing DC Page', component: DyeingDCDK },
    { path: '/bulk/general-dc', exact: true, name: 'General DC Page', component: GeneralDCDK },
    { path: '/bulk/general-dc-inward', exact: true, name: 'General DC Inward Page', component: GeneralDCInwardDK },
    { path: '/bulk/all-over-printing-dc-inward', exact: true, name: 'Printing DC Inward Page', component: PrintingDcInwardWrapperDK },
    { path: '/bulk/accessories-po', exact: true, name: 'Accessories PO Page', component: AccessoriesPoDK },
    { path: '/bulk/accessories-po-inward', exact: true, name: 'Accessories PO Inward Page', component: AccessoriesInwardDK },
    { path: '/bulk/all-over-printing-dc', exact: true, name: 'All Over Printing DC Page', component: PrintingDCDK },
    { path: '/all-over-printing-dc', exact: true, name: 'All Over Printing DC Page', component: AllOverPrintingDC },
    { path: '/all-over-printing-inward', exact: true, name: 'Printing DC Inward Page', component: AllOverPrintingDCInward },
    { path: '/bulk/printing-dc', exact: true, name: 'Printing DC Page', component: PrintingDC2DK },
    { path: '/bulk/compacting-dc-inward', exact: true, name: 'Compacting DC Inward Page', component: CompactingInwardDK },
    { path: '/bulk/washing-dc', exact: true, name: 'Washing DC Page', component: WashingDCDK },
    { path: '/bulk/washing-dc-inward', exact: true, name: 'Washing DC Inward Page', component: WashingInwardWrapperDK },
    { path: '/bulk/cutting-dc', exact: true, name: 'Cutting DC Page', component: CuttingDCDK },
    { path: '/bulk/accessories-dc', exact: true, name: 'Accessories DC Page', component: AccessoriesDCDK },
    { path: '/bulk/stitching-dc', exact: true, name: 'Stitching DC Page', component: StitchingDCDK },
    { path: '/bulk/printing-inward', exact: true, name: 'Printing Inward Page', component: Printing2InwardWrapperDK },
    { path: '/bulk/stitching-inward', exact: true, name: 'Stitching Inward Page', component: StitchingInwardWrapperDK },
    {
        path: '/bulk/ironing/packing-dc-inward',
        exact: true,
        name: 'Ironing/Packing DC Inward Page',
        component: IroningPackingInwardWrapperDK
    },
    {
        path: '/bulk/cutting-dc-inward',
        exact: true,
        name: 'Cutting DC Inward Page',
        component: CuttingInwardWrapperDK
    },
    {
        path: '/bulk/process-assign-style-master-basic',
        exact: true,
        name: 'Process Assign Style Master Basic Page',
        component: ProcessAssignStyleMasterDK
    },
    { path: '/bulk/compacting-dc', exact: true, name: 'Compacting DC Page', component: CompactingDCDK },
    { path: '/bulk/ironing-packing-dc', exact: true, name: 'Ironing Packing DC Page', component: IroningPackingDCDK },
    { path: '/ironing-and-packing-dc', exact: true, name: 'Ironing Packing DC Page', component: IroningPackingDC },
    { path: '/bill-receiving', exact: true, name: 'Bill Receiving', component: BillRecieving },
    { path: '/bill-receiving-verify', exact: true, name: 'Bill Receiving Verify', component: BillReceivingVerify },
    { path: '/bill-receiving-report', exact: true, name: 'Bill Receiving Report', component: BillRecievingReport },
];
export default routes;
